export const RoomType = {
  Living: "living",
  Dining: "dining",
  Kitchen: "kitchen",
  Hallway: "hallway",
  Staircase: "staircase",
  GuestToilet: "guest-toilet",
  Utility: "utility",
  Office: "office",
  Child: "child",
  Bathroom: "bathroom",
  Bedroom: "bedroom",
  Storage: "storage",
  Hobby: "hobby",
  Laundry: "laundry",
  HeatingRoom: "heating-room",
  UtilityConnectionRoom: "utility-connection-room",
  Garage: "garage",
  DetachedGarage: "detached-garage",
  Carport: "carport",
  Other: "other",
  Terrace: "terrace",
  Balcony: "balcony",
  Garden: "garden",
  Entrance: "entrance",
  GarageDriveway: "garage-driveway",
  RoofTerrace: "roof-terrace",
  PenthousePerimeter: "penthouse-perimeter",
  Roof: "roof",
} as const;

export type RoomType = (typeof RoomType)[keyof typeof RoomType];

/** Identifies rooms enclosed by exterior walls, including rooftop parapets. */
export function hasContinuousExteriorWalls(type: RoomType | undefined): boolean {
  return (
    type === RoomType.Garage ||
    type === RoomType.DetachedGarage ||
    type === RoomType.RoofTerrace ||
    type === RoomType.PenthousePerimeter
  );
}

/** Räume, deren angrenzende Wände baulich weiterhin als Außenwände gelten. */
export const SPECIAL_EXTERIOR_ROOM_TYPES: ReadonlySet<RoomType> = new Set([
  RoomType.Garage,
  RoomType.DetachedGarage,
  RoomType.Carport,
  RoomType.Terrace,
  RoomType.Balcony,
  RoomType.Garden,
  RoomType.Entrance,
  RoomType.GarageDriveway,
  RoomType.RoofTerrace,
  RoomType.PenthousePerimeter,
  RoomType.Roof,
]);

export function isSpecialExteriorRoomType(type: RoomType | undefined): boolean {
  return type !== undefined && SPECIAL_EXTERIOR_ROOM_TYPES.has(type);
}
